import { Tabs, TabsList, TabsTrigger } from '@quadminds/mindkit';
import { useTranslation } from 'react-i18next';

interface MobileTabNavigationProps {
    activeTab: string;
    onTabChange: (tab: string) => void;
    showPermissions?: boolean;
}

export function MobileTabNavigation({ activeTab, onTabChange, showPermissions }: MobileTabNavigationProps) {
    const { t } = useTranslation();

    return (
        <div className="md:hidden mt-4 border-t pt-4">
            <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
                <TabsList className="w-full">
                    <TabsTrigger value="preview" className="flex-1">
                        {t('fileModal.tabs.preview')}
                    </TabsTrigger>
                    <TabsTrigger value="info" className="flex-1">
                        {t('fileModal.tabs.information')}
                    </TabsTrigger>
                    {showPermissions && (
                        <TabsTrigger value="permissions" className="flex-1">
                            {t('fileModal.tabs.permissions')}
                        </TabsTrigger>
                    )}
                </TabsList>
            </Tabs>
        </div>
    );
}
